module.exports = __webpack_public_path__ + "img/nodensnew.png.6f3eec30.webp";